export const GET_STORE_SERVICES_RQ_KEY = "GET_STORE_SERVICES";
export const GET_STORE_SERVICE_RQ_KEY = "GET_STORE_SERVICE";
export const GET_STORE_SERVICES_ORDERS_RQ_KEY = "GET_STORE_SERVICES_ORDERS";
export const GET_STORE_SERVICE_ORDER_RQ_KEY = "GET_STORE_SERVICE_ORDER";
export const GET_STORE_SERVICE_CUSTOMER_ORDERS_RQ_KEY = "GET_STORE_SERVICES_ORDERS";
export const GET_STORE_SERVICE_CUSTOMER_ORDER_RQ_KEY = "GET_STORE_SERVICE_CUSTOMER_ORDER";
export const GET_STORE_SERVICES_SALES_AND_INSIGHTS_RQ_KEY =
  "GET_STORE_SERVICES_SALES_AND_INSIGHTS";
export const GET_STORE_SERVICES_SALES_AND_INSIGHTS_CUSTOMER_TRANSACTIONS_RQ_KEY =
  "GET_STORE_SERVICES_SALES_AND_INSIGHTS_CUSTOMER_TRANSACTIONS";
export const GET_STORE_SERVICE_PORTFOLIO_IMAGES_RQ_KEY =
  "GET_STORE_SERVICE_PORTFOLIO_IMAGES_RQ_KEY";
